import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { addCart } from "../redux/action";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";

const Products = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const componentMounted = useRef(true);
  const dispatch = useDispatch();
  
  const addProduct = (product)=>{
    dispatch(addCart(product))
  }


  useEffect(() => {
    const getProducts = async () => {
      setLoading(true);
      const response = await fetch("https://fakestoreapi.com/products/");
      const responseData = await response.json();
      if (componentMounted.current) {
        setData(responseData);
        setFilter(responseData);
        setLoading(false);
        console.log(responseData);
      }
    };
    getProducts();
    return () => {
      componentMounted.current = false;
    };

    
  }, []);

  const Loading = () => {
    return (
      <>
        <div className="col-12 py-5 text-center">
          <Skeleton height={40} width={560} />
        </div>
        <div className="col-md-4 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 mb-4">
          <Skeleton height={592} />
        </div>
        <div className="col-md-4 mb-4">
          <Skeleton height={592} />
        </div>
      </>
    );
  };

  const filterProduct = (cat) =>{
    const updatedList = data.filter((item) => item.category === cat);
    setFilter(updatedList);
  }
  const ShowProducts = () => {
    return (
      <>
        <div className="buttons col-12 d-flex justify-content-center py-5">
          <button className="btn btn-outline-dark mx-2" onClick={()=>setFilter(data)}>All</button>
          <button className="btn btn-outline-dark mx-2" onClick={()=>filterProduct("men's clothing")}>Men's Clothing</button>
          <button className="btn btn-outline-dark mx-2" onClick={()=>filterProduct("women's clothing")}>
            Women's Clothing
          </button>
          <button className="btn btn-outline-dark mx-2" onClick={()=>filterProduct("jewelery")}>Jewelery</button>
          <button className="btn btn-outline-dark mx-2" onClick={()=>filterProduct("electronics")}>Electronics</button>
        </div>

        {filter.map((product) => {
          return (
            <>
              <div id={product.id} className="col-md-4 mb-4">
                <div class="card text-center h-100" key={product.id}>
                  <img
                    class="card-img-top p-3"
                    src={product.image}
                    alt="Card"
                    height={300}
                  />
                  <div class="card-body">
                    <h5 class="card-title">
                      {product.title.substring(0, 12)}...
                    </h5>
                    <p class="card-text">
                      {product.description.substring(0, 90)}...
                    </p>
                  </div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item lead">$ {product.price}</li>
                    {/* <li class="list-group-item">Dapibus ac facilisis in</li>
                    <li class="list-group-item">Vestibulum at eros</li> */}
                  </ul>
                  <div class="card-body">
                    <Link to={"/product/" + product.id} class="btn btn-dark m-1">                      
                        Buy Now
                    </Link>
                    <button class="btn btn-dark m-1" onClick={()=>addProduct(product)}>
                      Add to Cart
                    </button>
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </>
    );
  };
  return (
    <>
      <div className="container my-3 py-3">
        <div className="row">
          <div className="col-12">
            <h2 className="display-5 text-center">Latest Products</h2>
            <hr />
          </div>
        </div>
        <div className="row justify-content-center">
          {loading ? <Loading /> : <ShowProducts />}
        </div>
      </div>
    </>
  );
};

export default Products;